import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    minHeight: 200
  },
  formControl: {
    margin: theme.spacing(1)
  },
  bold: {
    fontWeight: 'bold'
  },
  headerRightSection: {
    flex: 1,
    textAlign: 'right',
    flexDirection: 'row-reverse'
  }
}));
